//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBody.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectFace.js";
import "../no/SelectBodyList.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BodyMotionType",1,0],[0,"CloneObject",0,"Tooling.CloneObject",0],[0,"ComponentMotionType",1,0],[1,"CopyBodySelection",0,"SelectBody",1],[1,"CopyComponentSelection",0,"Assemblies.SelectComponent",0],[0,"DestinationCsys",1,"CoordinateSystem",0],[1,"DestinationFace",0,"SelectFace",0],[0,"FromCsys",1,"CoordinateSystem",0],[1,"FromFace",0,"SelectFace",0],[0,"ManipulatorMatrix",1,0],[0,"ManipulatorOrigin",1,0],[0,"MoveHandlesOnly",1,0],[0,"NewComponent",1,0],[0,"NumberOfBodies",1,0],[0,"NumberOfComponents",1,0],[0,"RotateAngle",1,0],[0,"RotateVector",1,"Axis",0],[1,"SelectedBodies",0,"SelectBodyList",0],[0,"Type",1,0]],[[[],"BeginDrag",{},0,0],[[],"Drag",{},0,0],[[],"EndDrag",{},0,0]],[]];
SPLM.Tooling.ReferenceCopyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ReferenceCopyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ReferenceCopyBuilder.Types = Object.freeze({
    "Component" : "Component", "Body" : "Body"});

SPLM.Tooling.ReferenceCopyBuilder.ComponentMotionTypes = Object.freeze({
    "Dynamic" : "Dynamic", "CSYSToCSYS" : "CSYSToCSYS", "Angle" : "Angle", "FaceToFace" : "FaceToFace"});

SPLM.Tooling.ReferenceCopyBuilder.BodyMotionTypes = Object.freeze({
    "Dynamic" : "Dynamic", "CSYSToCSYS" : "CSYSToCSYS", "Angle" : "Angle", "FaceToFace" : "FaceToFace"});

export default SPLM;